export const GET_EVENT_TYPES_REQUEST = "GET_EVENT_TYPES_REQUEST";
export const GET_EVENT_TYPES_SUCCESS = "GET_EVENT_TYPES_SUCCESS";
export const GET_EVENT_TYPES_FAILURE = "GET_EVENT_TYPES_FAILURE";

export const GET_EVENTS_REQUEST = "GET_EVENTS_REQUEST";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FAILURE = "GET_EVENTS_FAILURE";

export const DELETE_EVENT_REQUEST = "DELETE_EVENT_REQUEST";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAILURE = "DELETE_EVENT_FAILURE";
